import React, { Component } from 'react';
import {connect} from 'react-redux';
import {selectDate} from '../../actions';

import {Api,Today} from '../../util';

import FilterContainer from '../FilterContainer';
import ContentContainer from './ContentContainer';
import Channel from '../../components/channel';

class FileContainer extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }
  componentDidMount(){
  }
  componentWillReceiveProps(nextProps){
  }


  render() {
    const {
      display, 
      selectedMenu
    } = this.props;
    const style = {display: display ? 'flex' : 'none'};

    return (
      <div className='content container schedule' style={style}>
        {selectedMenu === 'FILE' ?<FilterContainer  /> : null}
        {selectedMenu === 'FILE' ? <Channel />  : null}
        <div className='list cover'></div>
        <ContentContainer />  
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    selectedMenu: state.selectedMenu
  }
};

FileContainer = connect(mapStateToProps)(FileContainer);


export default FileContainer;


// WEBPACK FOOTER //
// ./src/containers/file/index.js